import { Container, SkeletonText } from '@chakra-ui/react';
import { useContentGroup } from 'features/content-groups/hooks/useContentGroup';
import { useParams } from 'react-router-dom';
import { FormData } from '../forms/FormData';
import LayoutAgendaSteps from './LayoutAgendaSteps';

export default function PageCreateAgenda() {
  const { id } = useParams() as { id: string };
  const { data: contentGroup, isLoading } = useContentGroup(id);
  
  return (
    <LayoutAgendaSteps>
      <Container 
        variant="internal"
        flexDirection="column" 
        mb="80px"
        minH="900px"
      >
        <SkeletonText isLoaded={!isLoading}>
        { contentGroup && (
          <FormData
            contentGroup={contentGroup}
          />
        )}
        </SkeletonText>
      </Container>
    </LayoutAgendaSteps>
  );
}
